// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__LSlUh","question":"Question_question__RfWP0","description":"Question_description__1avsQ"};